<div class="location-details show" *ngIf="location">
  <div class="location-details-container">
    <div class="info-container">
      <div class="logo-container notch-safe-area">
        <ng-container *ngIf="whitelabel$ | async as whitelabel">
          <img class="logo" [src]="getLogo(whitelabel)" alt="white label"/>
        </ng-container>
        <div class="close-img-section">
          <ng-container *ngIf="location.imageURL; else noimageTemplate">
            <div class="image-panel" [bg-image]="location.imageURL">
              <img
                [src]="icon.close"
                (click)="closePopup()"
                data-qa="close-button"
                class="close"
                aria-label="close"
              alt="close"
              />
            </div>
          </ng-container>
          <ng-template #noimageTemplate>
            <div class="no-image">
              <img
                [src]="icon.close"
                (click)="closePopup()"
                data-qa="close-button"
                class="close"
                aria-label="close"
                alt="close"
              />
            </div>
          </ng-template>
        </div>
      </div>
      <div class="header">
        <div class="primary-details">
          <div class="loc-secondary-info" [class.locimageincluded]="showLocationImage">
            <div class="name">{{ location.name }}</div>
            <div class="address">{{ location.address }}</div>
          </div>
          <div class="loc-image-outer" *ngIf="showLocationImage">
            <img
              *ngIf="location.imageUrl"
              src="{{ imageBaseUrl + location.imageUrl}}"
              alt="loc Image"
            />
          </div>
          <div
            class="directions"
            (click)="getlocation(location.loc[0], location.loc[1])"
            data-qa="get-direction"
          >
            <img [src]="icon.getDirection" class="icon" alt="direction"/>
            <span class="info-text sub-text-decoration">{{
              'get-directions' | translate
            }}</span>
          </div>
          <div class="phone">
            <img [src]="icon.phone" class="icon" alt="phone icon"/>
            <a
              class="info-text sub-text-decoration"
              href="{{ 'tel:' + location.businessPhoneNumber }}"
              >&nbsp;{{ location.businessPhoneNumber }}</a
            >
          </div>
        </div>
        <div class="border"></div>
      </div>
    </div>
    <div class="secondary-details">
      <moduurnv2-location-operating-hours
        [location]="location"
      ></moduurnv2-location-operating-hours>
    </div>
    <div class="actions">
      <!-- <button class="action-item order-later"
        class="action-item order-later"
      data-qa="order-later"
        (click)="futureOrderFromOrganization(location)"
        [ngClass]="{ disable: !location?.orderSettings?.futureOrder?.isAllow }"
      >
        <img [src]="icon.orderForLater" class="item-image" alt="order for later"/>
        <span class="info-text">{{ 'order-later' | translate }}</span>
      </button>
      <button
        class="action-item order-now"
        [attr.data-qa]="'navigate-home-button-' + location._id"
        [class.disable]="!location.isLocationOpen"
        (click)="orderFromOrganization(location)"
        [ngClass]="{
          disable:
            !(
              !location?.orderSettings?.asapOrder?.isAllow &&
              !location?.orderSettings?.futureOrder?.isAllow
            ) && !location?.orderSettings?.asapOrder?.isAllow
        }"
      >
        <img
          class="item-image"
          [src]="location.isLocationOpen ? icon.orderHere : icon.orderHereWhite"
          alt="location"
        />
        <span class="info-text">{{ 'order-now' | translate }}</span>
      </button> -->
      <button
      class="action-item loc-order"
      [attr.data-qa]="'navigate-home-button-' + location._id"
      (click)="orderFromLocation(location)">
      <img
        class="item-image"
        [src]="icon.orderHere"
        alt="order here"
      />
      <span class="info-text">{{ 'order' | translate }}</span>
    </button>
    </div>
  </div>
</div>
